import * as Yup from 'yup'

export const PAYMENT_TYPE_FLOOR_PLAN = 78

export interface IMessage {
  isSuccess: boolean
  message: string
}

export const INITIAL_ADDRESS_VALUES = {
  address: '',
  address2: '',
  city: '',
  country: null,
  state: null,
  countryCode: null,
  stateCode: null,
  zipcode: ''
}

export const createUniqueEmailValidation = () =>
  Yup.string()
    .email('Invalid Email Address')
    .required('Enter Email Address')
    .test('unique-in-array', 'Email already exists', function (value) {
      if (!value || value.trim() === '') return true
      const { parent, path } = this
      const currentIndex = parseInt(path.split('[')[1]?.split(']')[0])
      const allEmails = parent || []

      const firstOccurrenceIndex = allEmails.findIndex((email) => email === value)

      return firstOccurrenceIndex === currentIndex
    })

export const validationSchema = Yup.object({
  CurBuyer: Yup.number().required('Default dealership is required').min(1, 'Please select a valid dealership'),
  PaymentTypeOther: Yup.string()
    .trim()
    .when('DefaultPaymentTypeID', {
      is: PAYMENT_TYPE_FLOOR_PLAN,
      then: (schema) => schema.required('Floor Plan Name is required when Floor Plan payment method is selected'),
      otherwise: (schema) => schema.notRequired()
    }),
  DefaultPaymentTypeID: Yup.number().min(0, 'Please select a valid payment method'),
  TransportCompanyID: Yup.number().min(0, 'Please select a valid transportation provider'),
  DeliveryModeID: Yup.number().min(0, 'Please select a valid delivery type'),
  DeliveryLocationID: Yup.number().min(0, 'Please select a valid delivery location'),
  DeliveryMethodID: Yup.number().min(0),
  curAccount: Yup.number().min(0, 'Please select a valid account'),
  UserID: Yup.number().min(0),
  SecretQuestion1: Yup.number().min(0),
  SecretQuestion2: Yup.number().min(0),
  DefaultContactID: Yup.number().min(0),
  IsReserveMatch: Yup.boolean(),
  DeliveryModeCode: Yup.string().trim(),
  DeliveryLocationCode: Yup.string().trim(),
  SecretAnswer1: Yup.string().trim(),
  SecretAnswer2: Yup.string().trim(),
  DeliveryColleciton: Yup.string().trim(),
  PurchaseEmails: Yup.array().of(createUniqueEmailValidation()),
  SoldEmails: Yup.array().of(createUniqueEmailValidation())
})
